import * as PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import styles from './Connector.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
const cln = classnames.bind(styles);

/**
 * This component allows to group items together by removing rounded corners from middle components.
 * Please note that it works only on immediate children so nested components like e.g. buttons will not be affected.
 */
function Connector({
  children,
  gap = 0,
  className,
  flow = 'row',
  style,
  ...rest
}) {
  const classes = cln(className, `Connector--${flow}`);
  const customStyles = {
    [flow === 'column' ? 'gridRowGap' : 'gridColumnGap']: gap,
    ...style
  };
  return /*#__PURE__*/_jsx("div", {
    style: customStyles,
    className: classes,
    ...rest,
    children: children
  });
}
Connector.propTypes = {
  /** @ignore */
  children: PropTypes.node.isRequired,
  /** Determines items flow */
  flow: PropTypes.oneOf(['column', 'row']),
  /** Defines size of a gap between connected items in px */
  gap: PropTypes.number,
  /** Optional custom className  */
  className: PropTypes.string,
  /** @ignore */
  style: PropTypes.object
};
export default Connector;